import { HOME_PREVIEW_PATH, NAV_TYPE } from '@/utils/constants';

export const PC_NAV_DRAFT_PREVIEW_HEADER = 'X-PC-Nav-Draft-Preview';

type PcNavDraftPreviewParams = {
  isWeb: boolean;
  pathname: string | null | undefined;
  previewType: string | null | undefined;
};

/** 仅 PC 顶部导航的固定预览入口可以读取草稿导航。 */
export function isPcNavDraftPreview({
  isWeb,
  pathname,
  previewType,
}: PcNavDraftPreviewParams): boolean {
  return isWeb && pathname === HOME_PREVIEW_PATH && previewType === String(NAV_TYPE.WEB_HEADER);
}
